import { render, staticRenderFns } from "./AdvertisersTable.vue?vue&type=template&id=680764eb&"
import script from "./AdvertisersTable.vue?vue&type=script&lang=js&"
export * from "./AdvertisersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports